import { NOT_SUITABLE_STAGE, OFFER_SENT_STAGE } from "../strings";

export const translatedStaticStages = {
  new: "Noch nicht kontaktiert",
  contact_attempt: "Kontaktversuch",
  appointment_failed: "Warte auf Kundeninformationen",
  appointment_agreed: "Termin vereinbart",
  appointment_is_done: "Termin erfolgt",
  [OFFER_SENT_STAGE]: "Angebot versendet",
  assignment: "Auftrag",
  not_suitable: "Nicht geeignet",
  archived: "Archiviert",
  all: "Alle",
  deleted: "Gelöscht",
  application_received: "Bewerbung eingegangen",
  phone_interview: "Telefongespräch",
  interview: "Bewerbungsgespräch",
  screening: "Bewertung",
  offer: "Angebot",
  hired: "Eingestellt"
};

// lead & applicant stages
// NOT IN USE
const black = { color: "#ffffff", background: "#000000" };
const darkGray = { color: "#ffffff", background: "#808080" };
const red = { color: "#f5222d", background: "#fff1f0", border: "#ffa39e" };
const blue = { color: "#1890ff", background: "#e6f7ff", border: "#91d5ff" };
const green = { color: "#52c41a", background: "#f6ffed", border: "#b7eb8f" };
const orange = { color: "#fa8c16", background: "#fff7e6", border: "#ffd591" };

export const stagesHash = [
  { title: "Noch nicht kontaktiert", value: "new", ...darkGray },
  { title: "Kontaktversuch", value: "contact_attempt", ...orange },
  { title: "Warte auf Kundeninformationen", value: "appointment_failed" },
  { title: "Termin vereinbart", value: "appointment_agreed", ...blue },
  { title: "Termin erfolgt", value: "appointment_is_done" },
  { title: "Angebot versendet", value: OFFER_SENT_STAGE },
  { title: "Auftrag", value: "assignment", ...green },
  { title: "Nicht geeignet", value: NOT_SUITABLE_STAGE, ...red },
  { title: "Archiviert", value: "archived", ...black },
  { title: "Alle", value: "all" },
  { title: "Gelöscht", value: "deleted" },
  {
    title: "Bewerbung eingegangen",
    value: "application_received",
    ...darkGray
  },
  { title: "Telefongespräch", value: "phone_interview", ...blue },
  { title: "Bewerbungsgespräch", value: "interview" },
  { title: "Bewertung", value: "screening" },
  { title: "Angebot", value: "offer" },
  { title: "Eingestellt", value: "hired", ...green }
];

export const notSuitableReasons = {
  too_little_budget: "Zu wenig Budget",
  no_longer_available: "Nicht mehr erreichbar",
  bought_somewhere_else: "Hat woanders gekauft",
  has_changed_his_mind: "Hat sich umentschieden",
  another_product: "Möchte ein anderes Produkt",
  wrong_telephone: "Falsche Telefonnummer",
  request_too_far_away: "Anfrage zu weit entfernt",
  disagree_on_the_conditions: "Nicht einig bei den Konditionen",
  no_want_to_change: "Möchte nicht wechseln",
  no_fit_humanly: "Passt menschlich nicht",
  no_fit_technically: "Passt fachlich nicht",
  too_far_away: "Zu weit entfernt",
  appointment_cancelled: "Termin abgesagt - kein Interesse",
  duplicate_inquiry: "Doppelte Anfrage",
  language_barrier: "Sprachbarriere",
  drivers_license_missing: "Führerschein fehlt",
  canceled_by_user: "Hat selber abgesagt",
  did_not_show_up_for_appointment: "Nicht zum Termin erschienen"
};

const staticStages = [
  { id: "new", name: "Noch nicht kontaktiert" },
  { id: "contact_attempt", name: "Kontaktversuch" },
  { id: "appointment_failed", name: "Warte auf Kundeninformationen" },
  { id: "appointment_agreed", name: "Termin vereinbart" },
  { id: "appointment_is_done", name: "Termin erfolgt" },
  { id: OFFER_SENT_STAGE, name: "Angebot versendet" },
  { id: "assignment", name: "Auftrag" },
  { id: NOT_SUITABLE_STAGE, name: "Nicht geeignet" },
  { id: "archived", name: "Archiviert" },
  { id: "all", name: "Alle" },
  { id: "deleted", name: "Gelöscht" },
  { id: "application_received", name: "Bewerbung eingegangen" },
  { id: "phone_interview", name: "Telefongespräch" },
  { id: "interview", name: "Bewerbungsgespräch" },
  { id: "screening", name: "Bewertung" },
  { id: "offer", name: "Angebot" },
  { id: "hired", name: "Eingestellt" }
];

export const dealStageOptions = stagesHash.map((stage) => ({
  name: stage.title,
  _id: stage.value
}));

export const getDealStageTitle = (stageValue) => {
  const stage = staticStages.find((s) => s.id === stageValue);
  return stage ? stage.name : stageValue;
};
